import React, {useState, useEffect, useCallback} from 'react';
import Table from '../components/table/table';
import SubNav from '../components/subNav/subNav';
import CertificatesData from '../data/certificates.json';
const { certificatesData } = { ...CertificatesData}
import DisplayModal from '../modals/displayModal/displayModal';
import { createCertificateData, updateCertificateData, fetchCertificateData, deleteCertificateData, uploadCertificate, fetchCertificateGlobalSearchData, downloadCert } from '../api/certificatesApi';
import generateFileUploadDetails from '../integration/generateFileDetails';
import createFileRecord from '../integration/createFileRecordData';
import Loader from '../components/loader/loader';
import { exportToExcel } from '../functions/exportToExcel';
import debouce from 'lodash/debounce';
import handle_toast  from '../genericFunctions/toast_Handler';
import { DownloadDocument } from '../functions/downloadDocuments';

const Certificate = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [dataFetched, setDataFlag] = useState(false);
  const [certData, setCertData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const accessData = sessionStorage.getItem('accessData') ? JSON.parse(sessionStorage.getItem('accessData'))['Certificate'] : {};

  const toggleModal = () => {
      setModalVisible(!modalVisible);
      if(modalVisible == false) {
        const dropDownData = sessionStorage.getItem('dropDownData') ? JSON.parse(sessionStorage.getItem('dropDownData')) : {};
        delete dropDownData.PAIList;
        delete dropDownData.MACList;
        sessionStorage.setItem('dropDownData', JSON.stringify(dropDownData));
      }
  }

  // debounce call
  const debouncedCall = useCallback(
    debouce(()=> {
      fetchCertificates();
    }, 500), //Adjusting the delay
    []
  );

  useEffect(() => {
    if(!dataFetched) debouncedCall();
    
    //Clean up the debounce on component unmount
    return () => {
      debouncedCall.cancel();
    };
  }, [dataFetched, debouncedCall])

  const fetchCertificates = async () => {
    setIsLoading(true)
    try{
      const resp = await fetchCertificateData();
      setDataFlag(true)
      setCertData(resp?.data?.data)
      setIsLoading(false)
      handle_toast({message: `Certificates data fetched`, status: 'success'})
    }
    catch(error){
      setIsLoading(false)
      setDataFlag(true);
      handle_toast(error)
    }
  }  

  const fetchGlobalSearch = async (searchFormFields) => {
    try{
      const resp = await fetchCertificateGlobalSearchData(searchFormFields);
      setIsLoading(false);
      setDataFlag(true)
      setCertData(resp?.data?.globalSearchData)
      handle_toast({message: `Filtered certificates data fetched`, status: 'success'})
    }
    catch(error){
      setIsLoading(false)
      setDataFlag(true);
      handle_toast(error)
    }
  }

  const handleUpload = async (formValue) => {
    const formData = generateFileUploadDetails('DAC', formValue)
      try{
          const resp = await uploadCertificate(formData);
          handle_toast({message: `File Uploaded: ${formValue.fileName}`, status: 'success'})
          const recordData = createFileRecord(formValue, resp?.data, 'DAC');
          const completeForm = {...formValue, ...recordData}
          try{
              const firmResp = await createCertificateData(completeForm)
              await fetchCertificates()
              handle_toast({message: `DAC Certificate Data Saved for File: ${firmResp.data.data.fileName}`, status: 'success'})
          }
          catch(error){
            handle_toast(error)
          }
      }
      catch(error){
        handle_toast(error)
      }
  }

  const handleEdit = async (formData) => {
    setIsLoading(true)
    try{
      const resp = await updateCertificateData(formData)
      if(resp?.status == 200) {
        handle_toast({message: `Certificate Updated`, status: 'success'})
        fetchCertificates();
      }
    }
    catch(error){
      setIsLoading(false)
      handle_toast(error)
    }
  }

  const handleDelete = async (formData) => {
    setIsLoading(true)
    try{
      const resp = await deleteCertificateData(formData)
      if(resp?.status == 200) {
        handle_toast({message: `Certificate Deleted`, status: 'success'})
        fetchCertificates();
      }
    }
    catch(error){
      setIsLoading(false)
      handle_toast(error)
    }
  }

  const handleCertDownload = async (formData) => {
    try{
      const response = await downloadCert(formData);
      DownloadDocument(response, formData);
    }
    catch(error){
      handle_toast(error)
    }
  }

  const excelExport = () => {
    exportToExcel(certData, certificatesData.certificatesHeaders, 'Certificate')
  }

  return (
    <>
    {isLoading && <Loader/>}
    {!isLoading && <SubNav data = {certificatesData.certificatesSubNav} access={accessData} handleModalClick={toggleModal} sendReset={fetchCertificates} excelExport={excelExport} handleDDSearch={fetchGlobalSearch}></SubNav>}
    <se-container>
      <se-divider option='vertical'></se-divider>
      <div className='tableContainer'>
        <Table columns={certificatesData.certificatesHeaders} access={accessData} body={certData} modalData={certificatesData.certificatesModalData} onSave={handleEdit} onDelete={handleDelete} selection={false} page='certificates' onDownload={handleCertDownload}/>
      </div>                
    </se-container>   
    {modalVisible && <DisplayModal toggleModal={toggleModal} data={certificatesData.certificatesModalData} source="create" page="certificate" onSave={handleUpload}/>} 
    </>
  );
};

export default Certificate;

